import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getAggregateBranchesReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import { reportAggregateBranchesCrumb } from 'utils/breadcrumbInfo';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import WithRouter from 'custom/withRouter';
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';

class AggregateBranches extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1),
            `AggregateBranchesBeginDate`);
        this.props.formInput(date, `AggregateBranchesEndDate`);
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/aggregatebranches?beginDate=${beginDate}&endDate=${endDate}`, "AggregateBranches");
        }
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');

        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getAggregateBranchesReport({ beginDate, endDate, pageNumber, pageSize });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.aggregateBranches && newProps.aggregateBranches.list && newProps.aggregateBranches.list.length > 0 ? newProps.aggregateBranches.list[0].totalRows : 0;
            this.setState({ totalRow: totalRow });
        }
    }

    render() {
        return (
            <Grid headerContent={reportAggregateBranchesCrumb}>
                <PageHeader title={LOOKUP.report.aggregateBranches.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-aggregate-branches-report" />}
                    description={LOOKUP.report.aggregateBranches.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    downloadReport={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <DateCurrentDisplay />
                }
                {
                    this.state.showBody && this.props.aggregateBranches &&
                    <CardSimple>
                        <Body
                            aggregateBranches={this.props.aggregateBranches}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                            loggedBranch={this.props.loggedBranch}
                            branchForm={this.props.branch}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        aggregateBranches: state.reports.aggregateBranches,
        loggedBranch: state.common.branchId,
        beginDate: state.form.AggregateBranchesBeginDate,
        endDate: state.form.AggregateBranchesEndDate
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAggregateBranchesReport: model => dispatch(getAggregateBranchesReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(AggregateBranches));